import { connect } from 'react-redux'
import { createDate, storeActions } from '@morawadigital/skynet-framework'
import Notification from '../../components/pages/Notification'
import { setDateRange, setDivisions, setNotificationGameFilterQuery } from '../../store/actions'

const mapStateToProps = state => {

    return {

        dateRangeFrom: createDate( state.ui.dateRangeFrom ),
        dateRangeTo:   createDate( state.ui.dateRangeTo   ),
        divisions:     state.ui.divisions || [],
        filterQuery:   state.ui.notificationGameFilterQuery || '',
        loading:       state.app.loading,
        token:         state.auth.token,
        user:          state.auth.user,

    }

}

const mapDispatchToProps = dispatch => {

    return {

        onComposeMessage:    message      => dispatch( storeActions.msg.setMessageDraft( message   ) ) && dispatch( storeActions.msg.setActiveDraftId( message.id ) ),
        onDateRangeChange:   ( from, to ) => dispatch( setDateRange( from, to                      ) ),
        onDivisionsChange:   divisions    => dispatch( setDivisions( divisions                     ) ),
        onFilterQueryChange: filterQuery  => dispatch( setNotificationGameFilterQuery( filterQuery ) ),
        onToggleLoading:     loading      => dispatch( storeActions.app.toggleLoading( loading     ) ),

    }

}

export default connect( mapStateToProps, mapDispatchToProps )( Notification )